import { Routes, RouterModule, CanActivate } from '@angular/router';
import { Pages } from './pages.component';
import { ModuleWithProviders } from '@angular/core';
import { CanActivateTeam } from '../common/services/permission/guard.service';
// noinspection TypeScriptValidateTypes

// export function loadChildren(path) { return System.import(path); };

export const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('../pages/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'register',
    loadChildren: () =>
      import('../pages/register/register.module').then((m) => m.RegisterModule),
  },
  {
    path: 'pages',
    component: Pages,
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('../pages/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
          ),
        canActivate: [CanActivateTeam],
      },
      // {
      //   path: 'quots', loadChildren: 'app/pages/Quotation/quotation.module#QuotsModule'
      // },
      {
        path: 'masters',
        loadChildren: () =>
          import('../pages/masters/masters.module').then(
            (m) => m.MastersModule
          ),
      },
      // {
      //   path: 'acvouchers', loadChildren: () => import('../pages/AccountVoucher/accountvoucher.module').then(m => m.AccountVouchersModule)
      // },
      // {
      //   path: 'purchases', loadChildren: () => import('../pages/Purchases/purchases.module').then(m => m.PurchasesModule)
      // },
      // {
      //   path: 'sales', loadChildren: () => import('app/pages/Sales/sales.module').then(m => m.SalesModule)
      // },
      {
        path: 'report',
        loadChildren: () =>
          import('../pages/DialogReport/dialogRep.module').then(
            (m) => m.ReportModule
          ),
      },
      // { path: 'estimate', loadChildren: 'app/pages/estimate/estimate.module#EstimateModule' },
      {
        path: 'configuration',
        loadChildren: () =>
          import('../pages/configuration/configuration.module').then(
            (m) => m.ConfigurationModule
          ),
      },
      {
        path: 'userManager',
        loadChildren: () =>
          import('../pages/userManager/userManager.module').then(
            (m) => m.UserManagerModule
          ),
      },
      {
        path: 'inventory',
        loadChildren: () =>
          import('../pages/Inventory/inventory.module').then(
            (m) => m.InventoryModule
          ),
      },
      {
        path: 'editors',
        loadChildren: () =>
          import('../pages/editors/editors.module').then(
            (m) => m.EditorsModule
          ),
      },
      {
        path: 'components',
        loadChildren: () =>
          import('../pages/components/components.module').then(
            (m) => m.ComponentsModule
          ),
      },
      // {
      //   path: 'charts',
      //   loadChildren: () =>
      //     import('../pages/charts/charts.module').then((m) => m.ChartsModule),
      // },
      {
        path: 'ui',
        loadChildren: () =>
          import('../pages/ui/ui.module').then((m) => m.UiModule),
      },
      {
        path: 'forms',
        loadChildren: () =>
          import('../pages/forms/forms.module').then((m) => m.FormsModule),
      },
      {
        path: 'tables',
        loadChildren: () =>
          import('../pages/tables/tables.module').then((m) => m.TablesModule),
      },
      // {
      //   path: 'maps',
      //   loadChildren: () =>
      //     import('../pages/maps/maps.module').then((m) => m.MapsModule),
      // },
      // {
      //   path: 'terminal',
      //   loadChildren: () =>
      //     import('../pages/terminal/terminal.module').then(
      //       (m) => m.TerminalModule
      //     ),
      //   canActivate: [CanActivateTeam],
      // },
      {
        path: 'backup-restore',
        loadChildren: () =>
          import('../pages/backupRestore/backup-restore.module').then(
            (m) => m.BackupRestoreModule
          ),
        canActivate: [CanActivateTeam],
      },
      {
        path: 'configuration',
        loadChildren: () =>
          import('../pages/configuration/configuration.module').then(
            (m) => m.ConfigurationModule
          ),
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('../pages/reports/report.module').then((m) => m.ReportsModule),
      },
    ],
  },
];

export const routing: ModuleWithProviders<any> = RouterModule.forChild(routes);
